import { render, staticRenderFns } from "./EditProductionParameters.vue?vue&type=template&id=ba72c928"
import script from "./EditProductionParameters.vue?vue&type=script&lang=js"
export * from "./EditProductionParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports